// extracted by mini-css-extract-plugin
export default {"settingsContainer":"Settings_settingsContainer__f6vbr"};